import permanent from "@/components/common/i18n/fpaManage/fpaPermanent";
import lto from "@/components/common/i18n/fpaManage/fpaLto";
import ltoCampaign from "@/components/common/i18n/fpaManage/fpaLtoCampaign";

export default {
    zh: {
        title: 'FPA',
        permanent: permanent.zh,
        lto: lto.zh,
        ltoCampaign: ltoCampaign.zh,
        report_title:'FPA报表',
        material_report_title:'FPA物料报表',
    },
    en: {
        title: 'FPA',
        permanent: permanent.en,
        lto: lto.en,
        ltoCampaign: ltoCampaign.en,
        report_title:'FPA Report',
        material_report_title:'FPA Material Report',
    }
}